import { validateField } from "./validateField";

export const validateForm = (
  form,
  fieldConfig
) => {
  const errors = {};

  Object.entries(fieldConfig).forEach(
    ([field, config]) => {
      const error = validateField({
        ...config,
        value: form[field],

        matchValue:
          field === "confirmPassword"
            ? form.password
            : undefined,
      });

      if (error) {
        errors[field] = error;
      }
    }
  );

  return {
    isValid:
      Object.keys(errors).length === 0,
    errors,
  };
};